// extracted by mini-css-extract-plugin
export var parcelRow = "_tk-0";